import CM from '@uiw/react-codemirror'
import { createElement } from 'react'

/**
 * Wraps @uiw/react-codemirror, applying a "p-invalid" class to the wrapper when invalid is set.
 * All other props are forwarded as CodeMirror options.
 *
 * @component
 * @param {Object} props - Component props, forwarded to CodeMirror except invalid
 * @param {boolean} [props.invalid] - Adds a "p-invalid" class to the wrapper when true
 * @param {Function} props.onChange - Called with the new editor value on change
 * @returns {JSX.Element}
 */
export default function CodeMirror(props) {
  const { invalid, ...options } = props

  /**
   * Forwards the new editor value to the onChange prop.
   *
   * @param {*} value - New editor content.
   * @returns {void}
   */
  const onChange = value => {
    props.onChange(value)
  }

  const options2 = {
    ...options,
    onChange: onChange
  }

  return (
    <div className={`codemirror-wrapper ${!!invalid && 'p-invalid'}`}>
      {createElement(CM, options2)}
    </div>
  )
}

CodeMirror.displayName = 'CodeMirror'
